<template>
  <div>
    <ele-pro-table
      ref="table"
      :datasource="url"
      :columns="columns"
      :where="where"
      :selection.sync="selection"
      :page-size="20"
      height="calc(100vh - 261px)"
      tool-class="ele-toolbar-form">
      <template slot="toolbar">
        <el-form
          :model="where"
          class="ele-form-search"
          size="small"
          @keyup.enter.native="reload"
          @submit.native.prevent>
          <el-row :gutter="10">
            <el-col :md="6">
              <el-form-item>
                <el-input v-model.trim="where.up_channel_name" placeholder="通道名称" clearable size="small" />
              </el-form-item>
            </el-col>
            <el-col :md="6">
              <el-form-item>
                <el-input v-model.trim="where.code_name" placeholder="控制器名" clearable size="small" />
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" size="small" @click="reload">查询</el-button>
                <el-button type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small" @click="openEdit(null, 'system')"
                  v-if="permission.includes('sys:dscolumn:add')">系统</el-button>
                <el-button type="success" icon="el-icon-plus" class="ele-btn-icon" size="small" @click="openEdit(null, 'external')"
                  v-if="permission.includes('sys:dscolumn:add')">外部</el-button>
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  class="ele-btn-icon"
                  size="small"
                  :disabled="!selection.length"
                  @click="removeBatch"
                  v-if="permission.includes('sys:dscolumn:dall')">删除</el-button>
                <el-button type="warning" icon="el-icon-refresh" class="ele-btn-icon" size="small" @click="initData"
                  v-if="permission.includes('sys:dscolumn:edit')">初始化</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
      <template slot="channel_source" slot-scope="{ row }">
        <dict-tag dict-code="channel_source" :value="isSelfBuilt(row) ? 1 : 2" />
      </template>
      <template slot="up_ctrl" slot-scope="{ row }">
        <el-button
          v-if="isSelfBuilt(row) && classRowsOf(row).length"
          type="text"
          size="small"
          @click="openClassView(row)">查看[{{ classRowsOf(row).length }}]</el-button>
        <span v-else-if="isSelfBuilt(row)" class="ele-text-secondary">查看[0]</span>
        <span v-else>{{ formatUpCtrl(row) }}</span>
      </template>
      <template slot="status" slot-scope="{ row }">
        <el-switch v-model="row.status" @change="editStatus(row)" :active-value="1" :inactive-value="2"
          v-if="permission.includes('sys:dscolumn:status')" />
      </template>
      <template slot="action" slot-scope="{ row }">
        <el-button
          v-if="isSelfBuilt(row) && permission.includes('sys:dscolumn:edit')"
          size="small"
          class="ele-btn-icon"
          :type="hasBindValue(row.resource_class_id) ? 'success' : 'primary'"
          @click="openClassConfig(row)">群组</el-button>
        <el-button size="small" type="primary" class="ele-btn-icon" @click="openEdit(row)"
          v-if="permission.includes('sys:dscolumn:edit')">编辑</el-button>
        <el-popconfirm class="ele-action" title="确定要删除此通道吗？" @confirm="remove(row)"
          v-if="permission.includes('sys:dscolumn:delete')">
          <el-button size="small" type="danger" class="ele-btn-icon" slot="reference">删除</el-button>
        </el-popconfirm>
      </template>
    </ele-pro-table>

    <column-edit
      :data="current"
      :add-mode="addMode"
      :channel-type-id="channelTypeId"
      :visible.sync="showEdit"
      :up-list="upList"
      @done="onEditDone" />

    <column-config-class
      v-if="showClassConfig"
      :visible.sync="showClassConfig"
      :data="configCurrent"
      @done="reload" />

    <el-dialog
      title="群组列表"
      :visible.sync="showClassView"
      width="620px"
      append-to-body
      :destroy-on-close="true"
      :lock-scroll="false"
      custom-class="ele-dialog-form">
      <div v-if="classViewTitle" class="ele-text-secondary" style="margin-bottom: 12px;">{{ classViewTitle }}</div>
      <el-table :data="classViewRows" border max-height="360" v-loading="classViewLoading">
        <el-table-column type="index" label="序号" width="70" align="center" />
        <el-table-column prop="classname" label="小组名称" min-width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="type_code" label="渠道类型" min-width="110" align="center">
          <template slot-scope="{ row }">
            <dict-tag v-if="row.type_code" dict-code="type_name" :value="row.type_code" />
            <span v-else class="ele-text-secondary"></span>
          </template>
        </el-table-column>
        <el-table-column prop="hit" label="命中" width="90" align="center">
          <template slot-scope="{ row }">
            {{ row.hit }}
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="showClassView = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ColumnEdit from './column-edit';

export default {
  name: 'ColumnData',
  components: {
    ColumnEdit,
    ColumnConfigClass: () => import('./column-config-class')
  },
  computed: {
    ...mapGetters(['permission'])
  },
  props: {
    channelTypeId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      url: '/ChannelColumnIn/index',
      columns: [
        { columnKey: 'selection', type: 'selection', width: 45, align: 'center', fixed: 'left' },
        {
          columnKey: 'channel_source',
          label: '通道来源',
          width: 100,
          align: 'center',
          resizable: false,
          slot: 'channel_source'
        },
        {
          prop: 'up_channel_name',
          label: '通道名称',
          showOverflowTooltip: true,
          minWidth: 140,
          align: 'center'
        },
        { prop: 'success_rate', label: '成功率', showOverflowTooltip: true, minWidth: 90, align: 'center' },
        {
          columnKey: 'up_ctrl',
          label: '群组 / 控制器',
          showOverflowTooltip: true,
          minWidth: 140,
          align: 'center',
          slot: 'up_ctrl'
        },
        { prop: 'jc_rate', label: '基础费率', showOverflowTooltip: true, minWidth: 90, align: 'center' },
        { prop: 'money_gz', label: '支持金额', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'status', label: '通道开关', minWidth: 90, align: 'center', slot: 'status' },
        { columnKey: 'action', label: '操作', width: 220, align: 'center', resizable: false, slot: 'action', fixed: 'right' }
      ],
      where: {
        channel_type_id: this.channelTypeId,
        up_channel_name: '',
        code_name: ''
      },
      selection: [],
      current: null,
      showEdit: false,
      addMode: '',
      configCurrent: null,
      showClassConfig: false,
      showClassView: false,
      classViewTitle: '',
      classViewRows: [],
      classViewLoading: false,
      classList: [],
      upList: []
    };
  },
  watch: {
    channelTypeId(val) {
      this.where.channel_type_id = val;
      this.where.up_channel_name = '';
      this.where.code_name = '';
      this.selection = [];
      this.reload();
    }
  },
  mounted() {
    this.loadFilters();
  },
  methods: {
    loadFilters() {
      Promise.all([
        this.$http.get('/Resourceclass/getClassList'),
        this.$http.get('/Uplist/getupList')
      ]).then(([classRes, upRes]) => {
        if (classRes.data.code === 0) this.classList = classRes.data.data || [];
        if (upRes.data.code === 0) this.upList = upRes.data.data || [];
      }).catch((e) => {
        this.$message.error(e.message);
      });
    },
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    onEditDone() {
      this.reload();
      this.$emit('types-changed');
    },
    isSelfBuilt(row) {
      if (!row) return false;
      if (row.channel_source != null && row.channel_source !== '') {
        return Number(row.channel_source) === 1;
      }
      const classId = row.resource_class_id;
      return classId != null && String(classId).trim() !== '' && String(classId).trim() !== '0';
    },
    hasBindValue(value) {
      return value != null && String(value).trim() !== '' && String(value).trim() !== '0';
    },
    formatUpCtrl(row) {
      const code = row && row.up_code;
      const ctrl = row && row.code_name;
      if (code && ctrl) {
        return `${code} / ${ctrl}`;
      }
      return code || ctrl || '无';
    },
    classRowsOf(row) {
      const ids = String((row && row.resource_class_id) || '')
        .split(',')
        .map((id) => Number(String(id).trim()))
        .filter((id) => id > 0);
      const classMap = {};
      (this.classList || []).forEach((item) => {
        classMap[Number(item.id)] = item;
      });
      return ids
        .map((id) => {
          const info = classMap[id];
          if (!info) {
            return null;
          }
          return {
            id,
            classname: info.classname,
            type_code: info.type_code,
            hit: null
          };
        })
        .filter(Boolean);
    },
    openClassView(row) {
      const rows = this.classRowsOf(row);
      if (!rows.length) return;
      this.classViewTitle = row && row.up_channel_name ? `通道：${row.up_channel_name}` : '';
      this.classViewRows = rows;
      this.showClassView = true;
      this.loadClassHitCounts(rows);
    },
    loadClassHitCounts(rows) {
      const ids = (rows || []).map((item) => Number(item.id)).filter((id) => id > 0);
      if (!ids.length) {
        return;
      }
      this.classViewLoading = true;
      this.$http.get('/Resourceclass/getHitCounts', { params: { ids: ids.join(',') } }).then((res) => {
        this.classViewLoading = false;
        if (res.data.code !== 0) {
          return;
        }
        const map = res.data.data || {};
        this.classViewRows = this.classViewRows.map((item) => ({
          ...item,
          hit: map[String(item.id)] != null ? Number(map[String(item.id)]) : 0
        }));
      }).catch(() => {
        this.classViewLoading = false;
      });
    },
    openEdit(row, mode) {
      if (row) {
        this.addMode = this.isSelfBuilt(row) ? 'system' : 'external';
      } else {
        this.addMode = mode || 'system';
      }
      this.current = row || null;
      this.showEdit = true;
    },
    openClassConfig(row) {
      this.configCurrent = row;
      this.showClassConfig = true;
    },
    remove(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/ChannelColumnIn/delete', { id: row.id }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.selection = [];
          this.reload();
          this.$emit('types-changed');
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error('请选择');
        return;
      }
      this.$confirm('确定要删除选中的通道吗?', '提示', { type: 'warning' }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/ChannelColumnIn/delete', {
          id: this.selection.map((d) => d.id)
        }).then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.selection = [];
            this.reload();
            this.$emit('types-changed');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    initData() {
      this.$confirm('初始化将清空全部代收通道且不可恢复，确定继续？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/ChannelColumnIn/initData').then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.selection = [];
            this.reload();
            this.$emit('types-changed');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    editStatus(row) {
      const loading = this.$loading({ lock: true });
      const prev = row.status === 1 ? 2 : 1;
      this.$http.post('/ChannelColumnIn/status', {
        id: row.id,
        status: row.status
      }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
        } else {
          row.status = prev;
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        row.status = prev;
        this.$message.error(e.message);
      });
    }
  }
};
</script>
